import React from 'react';
import { useParams } from "react-router-dom";
import ProductDetailSection from "../sections/product/detail/ProductDetailSection";
import RelatedProductsSection from "../sections/product/relatedProducts/RelatedProductsSection";

const ProductPage = () => {
    const { handle } = useParams<{ handle: string }>();

    if (!handle) {
        return null;
    }

    return (
        <>
            <ProductDetailSection handle={handle} />
            <RelatedProductsSection handle={handle} />
        </>
    );
};

export default ProductPage;
